var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.data &&
    _vm.data.reviews &&
    _vm.data.reviews.length >= 1 &&
    _vm.dataLoaded &&
    _vm.data.rating365 > 4
    ? _c("div", { staticClass: "ts-widget" }, [
        _c("div", { staticClass: "inner" }, [
          _c("div", { staticClass: "badgex" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "txt" }, [
              _c("strong", { staticClass: "rate" }, [
                _vm._v(_vm._s(_vm.data.rating365.toString().replace(".", ","))),
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "word",
                domProps: {
                  textContent: _vm._s(
                    _vm.data.rating365 > 4 ? "Sehr gut" : "Gut"
                  ),
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "rate-stars" }, [
                _c("span", [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "rate-full",
                      style: "width:" + _vm.data.rating365 * 20 + "%",
                    },
                    [
                      _c("i", { staticClass: "fa fa-star" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-star" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-star" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-star" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-star" }),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "total" }, [
                _vm._v("(" + _vm._s(_vm.data.overallCount) + ")"),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("svg", { staticClass: "hide" }, [
          _c("g", { attrs: { id: "svg_arrow" } }, [
            _c("rect", { attrs: { width: "20", height: "20", rx: "10" } }),
            _c("g", { attrs: { transform: "translate(7.75 6)" } }, [
              _c("path", {
                attrs: {
                  d: "M4.457.707.707,4.457l3.75,3.75",
                  transform: "translate(-0.707 -0.707)",
                  fill: "none",
                  stroke: "#fff",
                  "stroke-miterlimit": "10",
                  "stroke-width": "1",
                },
              }),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "icon",
        attrs: {
          href: "https://www.trustedshops.de/bewertung/info_X8E6C4E7BA7A8AB4C0482F062ADD8682E.html",
          target: "_blank",
        },
      },
      [
        _c("img", {
          staticClass: "lazyload",
          attrs: {
            src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAH0AQMAAADxGE3JAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAADVJREFUeNrtwTEBAAAAwiD7p/ZZDGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOX0AAAEidG8rAAAAAElFTkSuQmCC",
            "data-src":
              "https://cdn03.plentymarkets.com/7uqe7kjy3ccd/frontend/ts.webp",
            alt: "",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "rate-blank" }, [
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }